import { ObjectModel } from 'objectmodel';

const SimpleResult = new ObjectModel({
  id: String,
  success: Boolean,
  detail: [Object]
});

export { SimpleResult };



/** WEBPACK FOOTER **
 ** ./~/web-message-helper/models/Result.js
 **/